import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Software Installation & Updates"
                    description="Seamless Software Installation and Timely Updates
Stay ahead with the latest software and system updates. Our Remote Desktop Support team remotely installs, configures, and updates software on your devices to ensure they’re running the latest versions. Whether it’s new software installations or ensuring existing programs are up-to-date, we ensure minimal disruption and maximum system performance."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Troubleshooting & Issue Resolution"
                    description="Quick Diagnosis, Fast Solutions
Technical issues can happen at any time. Our Remote Desktop Support team is always ready to diagnose and fix problems efficiently. From system errors to unexpected malfunctions, we act quickly to resolve issues and minimize downtime, helping you get back on track as soon as possible."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="System Monitoring"
                    description="Proactive Monitoring to Prevent Problems Before They Arise
We continuously monitor your systems to detect potential issues before they escalate into significant problems. Our proactive approach allows us to identify vulnerabilities, performance bottlenecks, and other issues early, ensuring that your systems stay secure, efficient, and reliable."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Security Patching"
                    description="Keep Your Systems Safe with Timely Security Patches
Security is a top priority in today’s digital environment. We apply necessary security patches and updates to safeguard your systems from vulnerabilities and potential threats. Our remote patch management services ensure that your systems are always protected from the latest security risks without interrupting your workflow."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="User Assistance & Training"
                    description="Empowering Your Team with the Knowledge They Need
Our Remote Desktop Support services don’t just focus on fixing issues—we also provide user assistance and training to ensure your team is well-equipped to handle technical processes independently. Whether it’s guiding users through system functions or providing ongoing support, we help enhance productivity and confidence in using technology."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
